import * as React from "react";
import { IIconProps } from "./Icon";

const Icon = (props: IIconProps) => (
  <svg
    width={props.width}
    style={props.style}
    height={props.width}
    viewBox="0 -81 512 512"
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${props.className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
<g fillRule="evenodd">
<path d="m10 71.960938h430.039062v268.667968h-430.039062zm0 0" fill="#ffdc91"/>
<path d="m71.960938 10h430.039062v268.671875h-61.960938v-206.710937h-368.078124zm0 0" fill="#f4b537"/>
<path d="m225.019531 233.332031 107.507813-80.6875 107.511718-80.683593h-430.039062l107.511719 80.683593zm0 0" fill="#feca57"/>
<path d="m502 0h-175.019531c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10h165.019531v248.671875h-41.960938s0-196.648437 0-196.730469c-.046874-3.847656-2.339843-7.476562-5.847656-9.09375-1.273437-.585937-2.75-.886718-4.152344-.886718h-358.078124v-41.960938h165.019531c5.523437 0 10-4.476562 10-10s-4.476563-10-10-10h-175.019531c-5.523438 0-10 4.476562-10 10v51.960938h-51.960938c-1.273438 0-10 1.0625-10 10v268.667968c0 9.34375 9.328125 10 10 10h430.039062c2.257813 0 9.773438-1.875 10-10v-51.957031h51.960938c5.523438 0 10-4.480469 10-10v-268.671875c0-5.523438-4.476562-10-10-10zm-482 91.96875 139.929688 105.015625-139.929688 121.695313zm156.289062 117.292969 42.726563 32.066406c1.78125 1.335937 3.890625 2.003906 6.003906 2.003906s4.226563-.667969 6.003907-2.003906l42.726562-32.066406 139.550781 121.367187h-376.5625zm113.820313-12.277344 139.929687-105.015625v226.710938zm119.945313-115.023437-141.878907 106.480468c-.019531.011719-.035156.023438-.054687.039063l-43.101563 32.347656-43.105469-32.347656c-.015624-.015625-.03125-.027344-.050781-.039063l-141.878906-106.480468zm0 0"/>
<path d="m286.980469 20c5.507812 0 10-4.492188 10-10s-4.492188-10-10-10c-5.507813 0-10 4.492188-10 10s4.492187 10 10 10zm0 0"/>
</g>
  </svg>  
);

export default Icon;
